import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/homePage.vue";
import ProvinceContent from "../views/provinceContent.vue";
import NewsList from "../views/newsList.vue";
import ArcticleDetail from "../views/articleDetail.vue";
import AboutUs from "../views/aboutUs.vue";
import KeyList from "../views/keyList.vue";
import ServiceGuide from "../views/serviceGuide/serviceGuide.vue";
import GeoDataSecurityCheck from "../views/geoDataSecurityCheck.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/detail",
    name: "provinceContent",
    component: ProvinceContent,
  },
  {
    path: "/news",
    name: "news",
    component: NewsList,
  },
  {
    path: "/article",
    name: "article",
    component: ArcticleDetail,
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: AboutUs,
  },
  {
    path: "/keyList",
    name: "keyList",
    component: KeyList,
  },
  {
    path: "/serviceGuide",
    name: "serviceGuide",
    component: ServiceGuide,
  },
  {
    path: "/geoDataSecurityCheck",
    name: "geoDataSecurityCheck",
    component: GeoDataSecurityCheck,
  },
  {
    path: "/:path(.*)",
    component: HomePage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
